import { fmtDate } from "@/lib/format";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const STATUS_BADGE = {
  sent: "bg-primary/10 text-primary",
  sending: "bg-amber-100 text-amber-800",
  partial: "bg-amber-100 text-amber-800",
};
const STATUS_LABEL = { sent: "Sent", sending: "Sending", partial: "Partly sent", failed: "Failed" };

export const HistoryTab = ({ campaigns }) => (
  <Card className="shadow-sm">
    <CardContent className="p-0">
      <Table data-testid="campaigns-table">
        <TableHeader>
          <TableRow>
            <TableHead>Campaign</TableHead>
            <TableHead className="hidden md:table-cell">Sent to</TableHead>
            <TableHead className="text-right">Recipients</TableHead>
            <TableHead className="hidden sm:table-cell">Date</TableHead>
            <TableHead className="hidden md:table-cell">By</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {campaigns.length === 0 ? (
            <TableRow><TableCell colSpan={6} className="text-center py-8 text-muted-foreground" data-testid="no-campaigns-message">Nothing sent yet.</TableCell></TableRow>
          ) : campaigns.map((c) => (
            <TableRow key={c.id} data-testid={`campaign-row-${c.id}`}>
              <TableCell className="py-4">
                <p className="font-medium">{c.name}</p>
                <p className="text-xs text-muted-foreground">{c.subject}</p>
              </TableCell>
              <TableCell className="hidden md:table-cell text-muted-foreground">{c.segment_name}</TableCell>
              <TableCell className="text-right">{c.sent}/{c.recipient_count}{c.skipped_unsubscribed > 0 && <span className="text-xs text-muted-foreground"> (+{c.skipped_unsubscribed} unsub.)</span>}</TableCell>
              <TableCell className="hidden sm:table-cell text-muted-foreground">{fmtDate(c.sent_at)}</TableCell>
              <TableCell className="hidden md:table-cell text-muted-foreground">{c.sent_by}</TableCell>
              <TableCell>
                <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${STATUS_BADGE[c.status] || "bg-destructive/10 text-destructive"}`} title={c.error || undefined} data-testid={`campaign-status-${c.id}`}>
                  {STATUS_LABEL[c.status] || "Failed"}{c.preview_mode ? " (preview)" : ""}
                </span>
                {c.error && <p className="text-xs text-destructive mt-1 max-w-[220px]" data-testid={`campaign-error-${c.id}`}>{c.error}</p>}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </CardContent>
  </Card>
);
